(function (Translator) {
    Translator.fallback      = 'lt';
    Translator.defaultDomain = 'messages';
})(Translator);
